import { BaseDocument } from "./base";
import { UserId } from "./helpers";
import { FileMetadata } from "./storage";

export enum EChatMessageStatus {
    SENT = 'sent',
    READ = 'read',
    READ_BY_ALL = 'read-by-all',
    WITHDRAWN = 'withdrawn',
}

export enum EChatMessageType {
    TEXT = 'text',
    FILE = 'file',
    TEXT_AND_FILE = 'text-and-file',
    INVITATION = 'invitation',
}

export interface ChatMessage extends BaseDocument {
    sender: UserId
    conversationId: string;
    referenceId?: string; // e.g. if type is invitation, this is the id of the invitation
    content?: string;
    fileMeta?: FileMetadata;
    status?: EChatMessageStatus;
    type?: EChatMessageType;
    readByUsersAt: {
        userId: UserId;
        readAt: Date;
    }[]
}

export interface ChatProjectConversation extends BaseDocument {
    projectId: string;
    title: string;
    storageUrl: string,
    lastMessageAt?: Date;
    isArchived: boolean;
    archivedAt?: Date;
}

export interface ChatOneToOneConversation extends BaseDocument {
    createdBy: UserId;
    participants: UserId[];
    title: string;
    storageUrl: string,
    lastMessageType?: EChatMessageType;
    lastMessageAt?: Date;
    lastReadAt?: Date;
    lastMessageContent?: string;
    lastMessageFileMeta?: FileMetadata;
    lastMessageReferenceId?: string;
    isArchived: boolean;
    archivedAt?: Date;
    participantsNumberUnreadMessages: number[]; // unread messages by user id (same order as participants array)
}
